import { render, staticRenderFns } from "./TransferConversationTable.vue?vue&type=template&id=afbc3e86&scoped=true&"
import script from "./TransferConversationTable.vue?vue&type=script&lang=js&"
export * from "./TransferConversationTable.vue?vue&type=script&lang=js&"
import style0 from "./TransferConversationTable.vue?vue&type=style&index=0&id=afbc3e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbc3e86",
  null
  
)

export default component.exports